import React, { useEffect, useState } from 'react';
import { myAxios } from '../../services/Helper';
import './EquipmentRentalStyles.css';

const EquipmentRental = ({ functionId }) => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchItems = async () => {
            try {
                setLoading(true);

                if (functionId) {
                    // Fetch only items related to the selected subfunction
                    const response = await myAxios.get(`/api/SubfunctionCategory/items/bySubFunction1/${functionId}`);

                    if (!Array.isArray(response.data)) {
                        throw new Error('Invalid data format received');
                    }

                    // Ensure all items have proper number prices
                    setItems(response.data.map(item => ({
                        ...item,
                        itemPrice: item.itemPrice ? Number(item.itemPrice) : 0
                    })));
                } else {
                    // Fallback to fetching all items if no functionId is provided
                    const response = await myAxios.get('/api/subfunctionitem/subfunctionitem');

                    if (!Array.isArray(response.data)) {
                        throw new Error('Invalid data format received');
                    }

                    // Ensure all items have proper number prices
                    setItems(response.data.map(item => ({
                        ...item,
                        itemPrice: item.itemPrice ? Number(item.itemPrice) : 0
                    })));
                }

                setLoading(false);
            } catch (err) {
                setError(err.message || 'Failed to fetch items');
                setLoading(false);
                console.error('Fetch error:', err);
            }
        };

        fetchItems();
    }, [functionId]);

    if (loading) return <div className="status-message">Loading equipment items...</div>;
    if (error) return <div className="status-message error">Error: {error}</div>;

    return (
        <div className="equipment-rental-container">
            <h3 className="mb-4">Equipment Items</h3>
            <div className="table-responsive">
                <table className="equipment-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.length > 0 ? (
                            items.map((item) => (
                                <tr key={item.itemId}>
                                    <td>{item.itemId}</td>
                                    <td>{item.itemName}</td>
                                    <td>{item.itemDesc || 'N/A'}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" className="no-items">No equipment items found for this event package</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default EquipmentRental;



